var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 43,
    viewBox: "0 0 147 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.550497,
    y: 1.31014,
    width: 145.899,
    height: 41.1404,
    rx: 7.4495,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0174 23.7295C72.4278 23.7295 70.3172 25.6188 70.3172 28.2209C70.3172 30.8071 72.4278 32.7122 75.0174 32.7122C77.608 32.7122 79.7186 30.8071 79.7186 28.2209C79.7175 25.6188 77.6069 23.7295 75.0174 23.7295ZM75.0174 30.9444C73.5982 30.9444 72.375 29.8218 72.375 28.2219C72.375 26.6051 73.5993 25.4995 75.0174 25.4995C76.4365 25.4995 77.6597 26.6051 77.6597 28.2219C77.6597 29.8208 76.4365 30.9444 75.0174 30.9444ZM64.7627 23.7295C62.1732 23.7295 60.0625 25.6188 60.0625 28.2209C60.0625 30.8071 62.1732 32.7122 64.7627 32.7122C67.3533 32.7122 69.4639 30.8071 69.4639 28.2209C69.4639 25.6188 67.3533 23.7295 64.7627 23.7295ZM64.7627 30.9444C63.3435 30.9444 62.1203 29.8218 62.1203 28.2219C62.1203 26.6051 63.3446 25.4995 64.7627 25.4995C66.1819 25.4995 67.4051 26.6051 67.4051 28.2219C67.4062 29.8208 66.1819 30.9444 64.7627 30.9444ZM52.5659 25.1087V27.0138H57.32C57.1779 28.0857 56.8058 28.8682 56.2377 29.4121C55.5463 30.0753 54.464 30.8071 52.5659 30.8071C49.6394 30.8071 47.3516 28.544 47.3516 25.7371C47.3516 22.9301 49.6394 20.667 52.5659 20.667C54.1447 20.667 55.2974 21.2627 56.1485 22.0283L57.5501 20.6839C56.361 19.5952 54.7833 18.762 52.5659 18.762C48.5572 18.762 45.187 21.892 45.187 25.7371C45.187 29.5821 48.5572 32.7122 52.5659 32.7122C54.7293 32.7122 56.3621 32.031 57.6382 30.7553C58.9505 29.4966 59.359 27.7266 59.359 26.2978C59.359 25.8564 59.3238 25.4477 59.2522 25.1077H52.5659V25.1087ZM102.45 26.5882C102.06 25.585 100.871 23.7295 98.441 23.7295C96.0287 23.7295 94.0238 25.5502 94.0238 28.2209C94.0238 30.7385 96.0111 32.7122 98.6711 32.7122C100.817 32.7122 102.059 31.4534 102.574 30.7216L100.978 29.7004C100.446 30.4491 99.7182 30.9423 98.6711 30.9423C97.6252 30.9423 96.8798 30.4829 96.4009 29.581L102.662 27.0972L102.45 26.5882ZM96.064 28.0857C96.0111 26.3496 97.4655 25.4657 98.5126 25.4657C99.3284 25.4657 100.02 25.8575 100.251 26.4182L96.064 28.0857ZM90.9741 32.4408H93.0307V19.2393H90.9741V32.4408ZM87.6028 24.7338H87.5324C87.071 24.2058 86.1836 23.7295 85.0672 23.7295C82.7254 23.7295 80.5796 25.7033 80.5796 28.2388C80.5796 30.7564 82.7254 32.7132 85.0672 32.7132C86.1847 32.7132 87.071 32.237 87.5324 31.6931H87.6028V32.3394C87.6028 34.0576 86.645 34.9763 85.1025 34.9763C83.8429 34.9763 83.0623 34.1093 82.743 33.3775L80.9517 34.0924C81.4659 35.2826 82.8311 36.7462 85.1025 36.7462C87.5147 36.7462 89.5549 35.385 89.5549 32.0669V24.0031H87.6039V24.7338H87.6028ZM85.2445 30.9444C83.8253 30.9444 82.6373 29.8039 82.6373 28.2388C82.6373 26.6558 83.8253 25.4995 85.2445 25.4995C86.645 25.4995 87.7449 26.6558 87.7449 28.2388C87.7449 29.8039 86.645 30.9444 85.2445 30.9444ZM112.088 19.2393H107.165V32.4408H109.219V27.4394H112.087C114.364 27.4394 116.603 25.8585 116.603 23.3399C116.603 20.8212 114.365 19.2393 112.088 19.2393ZM112.141 25.6019H109.219V21.0768H112.141C113.677 21.0768 114.549 22.2965 114.549 23.3399C114.549 24.3621 113.677 25.6019 112.141 25.6019ZM124.837 23.7063C123.35 23.7063 121.81 24.3347 121.172 25.7276L122.995 26.4573C123.385 25.7276 124.112 25.4889 124.873 25.4889C125.935 25.4889 127.015 26.1003 127.033 27.187V27.3232C126.661 27.1194 125.863 26.8142 124.89 26.8142C122.925 26.8142 120.923 27.8502 120.923 29.7859C120.923 31.5527 122.535 32.69 124.341 32.69C125.721 32.69 126.483 32.0955 126.961 31.3985H127.032V32.4175H129.016V27.356C129.017 25.0137 127.191 23.7063 124.837 23.7063ZM124.589 30.9412C123.917 30.9412 122.978 30.6181 122.978 29.8197C122.978 28.8006 124.147 28.4099 125.157 28.4099C126.058 28.4099 126.484 28.5968 127.033 28.8513C126.873 30.0753 125.775 30.9412 124.589 30.9412ZM136.24 23.9946L133.885 29.7183H133.815L131.371 23.9946H129.158L132.823 31.9941L130.733 36.4442H132.876L138.525 23.9946H136.24ZM117.737 32.4408H119.79V19.2393H117.737V32.4408Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.207 11.5765C52.207 12.4615 51.934 13.1658 51.3868 13.6917C50.7658 14.3169 49.9555 14.6295 48.9602 14.6295C48.0067 14.6295 47.1953 14.3127 46.5292 13.6791C45.862 13.0444 45.5284 12.2587 45.5284 11.321C45.5284 10.3821 45.862 9.59645 46.5292 8.96283C47.1953 8.32815 48.0067 8.01134 48.9602 8.01134C49.4336 8.01134 49.8861 8.10005 50.3155 8.2764C50.746 8.45382 51.0906 8.68931 51.3482 8.98395L50.768 9.54153C50.3309 9.03992 49.7287 8.78964 48.9591 8.78964C48.2632 8.78964 47.6621 9.02408 47.1545 9.49296C46.647 9.96184 46.3938 10.5712 46.3938 11.3199C46.3938 12.0686 46.647 12.678 47.1545 13.1468C47.6621 13.6157 48.2632 13.8502 48.9591 13.8502C49.6967 13.8502 50.3122 13.6147 50.8043 13.1426C51.1236 12.8353 51.3086 12.4076 51.3581 11.8595H48.9591V11.0981H52.1597C52.1927 11.2639 52.207 11.4234 52.207 11.5765Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2827 8.93015H54.2748V10.9387H56.9876V11.7001H54.2748V13.7087H57.2827V14.4881H53.4259V8.15185H57.2827V8.93015Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8619 14.4881H60.013V8.93015H58.1678V8.15185H62.7072V8.93015H60.8619V14.4881Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9914 14.4881V8.15185H66.8403V14.4881H65.9914Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6047 14.4881H69.7559V8.93015H67.9106V8.15185H72.45V8.93015H70.6047V14.4881Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.043 13.6696C80.3934 14.3096 79.5864 14.6296 78.6208 14.6296C77.6553 14.6296 76.8482 14.3096 76.1998 13.6696C75.5502 13.0297 75.2265 12.2461 75.2265 11.3199C75.2265 10.3938 75.5502 9.61023 76.1998 8.97027C76.8482 8.33031 77.6553 8.00928 78.6208 8.00928C79.5809 8.00928 80.3868 8.33137 81.0386 8.97449C81.6904 9.61762 82.0163 10.3991 82.0163 11.3199C82.0163 12.2461 81.6915 13.0297 81.043 13.6696ZM76.8262 13.1384C77.3151 13.6137 77.9129 13.8502 78.6208 13.8502C79.3288 13.8502 79.9277 13.6126 80.4155 13.1384C80.9043 12.6632 81.1498 12.0571 81.1498 11.3199C81.1498 10.5828 80.9043 9.97667 80.4155 9.50145C79.9277 9.02624 79.3288 8.78969 78.6208 8.78969C77.9129 8.78969 77.3151 9.02729 76.8262 9.50145C76.3385 9.97667 76.093 10.5828 76.093 11.3199C76.093 12.0571 76.3385 12.6632 76.8262 13.1384Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2076 14.4881V8.15185H84.2403L87.4508 13.0804H87.4872L87.4508 11.8596V8.15185H88.2997V14.4881H87.4134L84.0543 9.31983H84.0179L84.0543 10.5406V14.4881H83.2076Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.207 11.5765C52.207 12.4615 51.934 13.1658 51.3868 13.6917C50.7658 14.3169 49.9555 14.6295 48.9602 14.6295C48.0067 14.6295 47.1953 14.3127 46.5292 13.6791C45.862 13.0444 45.5284 12.2587 45.5284 11.321C45.5284 10.3821 45.862 9.59645 46.5292 8.96283C47.1953 8.32815 48.0067 8.01134 48.9602 8.01134C49.4336 8.01134 49.8861 8.10005 50.3155 8.2764C50.746 8.45382 51.0906 8.68931 51.3482 8.98395L50.768 9.54153C50.3309 9.03992 49.7287 8.78964 48.9591 8.78964C48.2632 8.78964 47.6621 9.02408 47.1545 9.49296C46.647 9.96184 46.3938 10.5712 46.3938 11.3199C46.3938 12.0686 46.647 12.678 47.1545 13.1468C47.6621 13.6157 48.2632 13.8502 48.9591 13.8502C49.6967 13.8502 50.3122 13.6147 50.8043 13.1426C51.1236 12.8353 51.3086 12.4076 51.3581 11.8595H48.9591V11.0981H52.1597C52.1927 11.2639 52.207 11.4234 52.207 11.5765Z",
    stroke: "white",
    strokeWidth: 0.220199,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2827 8.93015H54.2748V10.9387H56.9876V11.7001H54.2748V13.7087H57.2827V14.4881H53.4259V8.15185H57.2827V8.93015Z",
    stroke: "white",
    strokeWidth: 0.220199,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8619 14.4881H60.013V8.93015H58.1678V8.15185H62.7072V8.93015H60.8619V14.4881Z",
    stroke: "white",
    strokeWidth: 0.220199,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9914 14.4881V8.15185H66.8403V14.4881H65.9914Z",
    stroke: "white",
    strokeWidth: 0.220199,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6047 14.4881H69.7559V8.93015H67.9106V8.15185H72.45V8.93015H70.6047V14.4881Z",
    stroke: "white",
    strokeWidth: 0.220199,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.043 13.6696C80.3934 14.3096 79.5864 14.6296 78.6208 14.6296C77.6553 14.6296 76.8482 14.3096 76.1998 13.6696C75.5502 13.0297 75.2265 12.2461 75.2265 11.3199C75.2265 10.3938 75.5502 9.61023 76.1998 8.97027C76.8482 8.33031 77.6553 8.00928 78.6208 8.00928C79.5809 8.00928 80.3868 8.33137 81.0386 8.97449C81.6904 9.61762 82.0163 10.3991 82.0163 11.3199C82.0163 12.2461 81.6915 13.0297 81.043 13.6696ZM76.8262 13.1384C77.3151 13.6137 77.9129 13.8502 78.6208 13.8502C79.3288 13.8502 79.9277 13.6126 80.4155 13.1384C80.9043 12.6632 81.1498 12.0571 81.1498 11.3199C81.1498 10.5828 80.9043 9.97667 80.4155 9.50145C79.9277 9.02624 79.3288 8.78969 78.6208 8.78969C77.9129 8.78969 77.3151 9.02729 76.8262 9.50145C76.3385 9.97667 76.093 10.5828 76.093 11.3199C76.093 12.0571 76.3385 12.6632 76.8262 13.1384Z",
    stroke: "white",
    strokeWidth: 0.220199,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2076 14.4881V8.15185H84.2403L87.4508 13.0804H87.4872L87.4508 11.8596V8.15185H88.2997V14.4881H87.4134L84.0543 9.31983H84.0179L84.0543 10.5406V14.4881H83.2076Z",
    stroke: "white",
    strokeWidth: 0.220199,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2840_5704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.49 8.72003C11.1697 9.04529 10.9803 9.55008 10.9803 10.2038V33.559C10.9803 34.2138 11.1697 34.7175 11.49 35.0428L11.5715 35.1188L25.2117 22.0356V21.8814V21.7272L11.5715 8.64294L11.49 8.72003Z",
    fill: "url(#paint0_linear_2840_5704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7575 26.3981L25.2115 22.0356V21.8814V21.7273L29.7586 17.3658L29.861 17.4218L35.2482 20.3576C36.7862 21.1961 36.7862 22.5679 35.2482 23.4074L29.861 26.3432L29.7575 26.3981Z",
    fill: "url(#paint1_linear_2840_5704)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2840_5704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8611 26.342L25.2105 21.8813L11.4899 35.0427C11.9964 35.5581 12.8342 35.6214 13.7778 35.1082L29.8611 26.342Z",
    fill: "url(#paint2_linear_2840_5704)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.8611 17.4207L13.7778 8.65557C12.8342 8.14128 11.9964 8.2057 11.4899 8.72104L25.2116 21.8824L29.8611 17.4207Z",
    fill: "url(#paint3_linear_2840_5704)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.550497,
    y: 1.31014,
    width: 145.899,
    height: 41.1404,
    rx: 7.4495,
    stroke: "#A6A6A6",
    strokeWidth: 1.10099
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2840_5704",
    x: 10.9803,
    y: 8.30066,
    width: 25.4214,
    height: 27.162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.165149
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2840_5704"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.165149
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2840_5704",
    result: "effect2_innerShadow_2840_5704"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2840_5704",
    x: 11.4899,
    y: 21.8813,
    width: 18.3712,
    height: 13.5813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.165149
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2840_5704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2840_5704",
    x1: 24.0026,
    y1: 9.95665,
    x2: 6.29565,
    y2: 28.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2840_5704",
    x1: 37.2503,
    y1: 21.8814,
    x2: 10.6108,
    y2: 21.8814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2840_5704",
    x1: 27.3356,
    y1: 24.3038,
    x2: 3.32267,
    y2: 49.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2840_5704",
    x1: 8.03435,
    y1: 0.946304,
    x2: 18.7568,
    y2: 12.1252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.4b735d7a09239f922384bde040a40149.svg";
export { ForwardRef as ReactComponent };